import { useLanguage } from "@languages/index"

export const COUNTRY_CD = {
  KR: "82",
  JP: "81",
}
